import { Box, Select, SelectMenuItem } from '@montugroup/design-system';

const STOCKTAKE_REASONS = [
  'BO Not Entered',
  'Damaged',
  'Dispensing Error',
  'Double Entry',
  'Expired',
  'Stock Receiving Error',
  'RTS',
  'Unsure/Unknown',
] as const;

const PLACEHOLDER = 'Select a reason…';

type StocktakeDiscrepancyReasonProps = {
  productId: number;
  reason: string | undefined;
  onReasonChange: (productId: number, reason: string | undefined) => void;
};

export function StocktakeDiscrepancyReason({ productId, reason, onReasonChange }: StocktakeDiscrepancyReasonProps) {
  return (
    <Select
      variant="standard"
      displayEmpty
      value={reason ?? ''}
      onChange={(evt) => onReasonChange(productId, evt.target.value || undefined)}
      fullWidth
      sx={{
        typography: 'body2',
        ...(!reason && { '&:before': { borderBottomColor: 'warning.main' } }),
      }}
      renderValue={(value) => value || <Box sx={{ color: 'warning.dark' }}>{PLACEHOLDER}</Box>}
    >
      <SelectMenuItem value="" disabled>
        {PLACEHOLDER}
      </SelectMenuItem>
      {STOCKTAKE_REASONS.map((stocktakeReason) => (
        <SelectMenuItem key={stocktakeReason} value={stocktakeReason}>
          {stocktakeReason}
        </SelectMenuItem>
      ))}
    </Select>
  );
}
